import _ from 'lodash';

export default (() => {

    function wrapErrorsInContainers(fieldErrors) {

        const wrappedErrors = _.mapValues(fieldErrors, wrapErrorsInContainer);

        return normaliseNestedErrors(wrappedErrors);
    }

    function wrapErrorsInContainer(errors) {

        return {
            errorContainer: errors
        };
    }

    function isInteger(number) {

        return number % 1 === 0;
    }

    function initialiseError(childKey) {

        if (isInteger(childKey)) {

            return [];

        } else {

            return {};
        }
    }

    function normaliseNestedErrors(formErrors) {

        var normalisedErrors = {};

        for (let errorKey in formErrors) {

            if (formErrors.hasOwnProperty(errorKey)) {

                const errors = formErrors[errorKey];

                if (errorKey.indexOf('.') !== -1) {

                    const parentKey   = errorKey.split('.')[0];
                    const childKey    = errorKey.split('.')[1];
                    const subChildKey = errorKey.split('.')[2];

                    if (!normalisedErrors[parentKey]) {

                        normalisedErrors[parentKey] = initialiseError(childKey);
                    }

                    if (isInteger(childKey)) {

                        if (!normalisedErrors[parentKey][childKey]) {

                            normalisedErrors[parentKey][childKey] = {};
                        }

                        normalisedErrors[parentKey][childKey][subChildKey] = errors;

                    } else {

                        normalisedErrors[parentKey][childKey] = errors;
                    }

                } else {

                    normalisedErrors[errorKey] = errors;
                }
            }
        }

        return normalisedErrors;
    }

    function apiErrorsToFormErrors(fieldErrors, message) {

        let wrappedErrors = wrapErrorsInContainers(fieldErrors);

        wrappedErrors._error = message;

        return wrappedErrors;
    }
    
    return {
        apiErrorsToFormErrors
    };
    
})();


// WEBPACK FOOTER //
// ./services/responseFormatter.js